import { Box } from '../../Box';
import { XMarkIcon } from '../../Icons';
import { useInterstateTheme } from '../../InterstateThemeProvider';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * A component for closing a toast notification.
 *
 * @param {ToastCloseProps} props - The props for the component.
 * @returns {JSX.Element} The rendered component.
 */
export const ToastClose = props => {
  const theme = useInterstateTheme();
  const {
    onClick
  } = props;
  return /*#__PURE__*/_jsx(Box, {
    width: '42px',
    minWidth: '42px',
    maxWidth: '42px',
    padding: '4px 4px  0 6px',
    children: /*#__PURE__*/_jsx(Box, {
      width: '32px',
      minWidth: '32px',
      maxWidth: '32px',
      height: '32px',
      minHeight: '32px',
      maxHeight: '32px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      onClick: onClick,
      sx: {
        cursor: 'pointer'
      },
      children: /*#__PURE__*/_jsx(XMarkIcon, {
        fontSize: '14px',
        color: theme.tokens.SemColorOnSurfaceSubdued
      })
    })
  });
};